export function shouldRedirectToLogin(url) {
  const path = String(url).split("?")[0];
  if (path.includes("/auth/me") || path.includes("/auth/login")) {
    return false;
  }
  if (path === "/vpn" || path.startsWith("/vpn/")) {
    return false;
  }
  if (path.includes("/api/vpn/") && !path.includes("/api/admin/vpn/")) {
    return false;
  }
  return true;
}
